module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko_samples/sec04_sp_0361a3137db376ee017fdbee65f46666.jpg";